import React from 'react'
import {renderIf, renderIfElse} from "../../../views/Shared";
import Translate from "../../../modules/local/Translate";
import HeaderGroupItem from "../../ItemLayout/HeaderGroupItem";
import classNames from "classnames";
import {renderEmptyHolderMember} from "../../../views/AppLocals/CatholicHousehold/functions/renderEmptyHolderMember";
import {formatDate} from "../../../helpers/datetimeHelpers";

export const renderMetadata = ( metadata = [], showHeader = true, className = 'text-sm' ) => {

    const emptyMetadata = metadata.every(e => e.answer_value === null)

    return (
        <Translate>
            {(t) => (
                <div className="flex flex-col gap-2">
                    {renderIf(
                        showHeader,
                        <HeaderGroupItem title="manager information"/>
                    )}
                    {renderIfElse(
                        !emptyMetadata,
                        metadata.map((eee, iii) => {
                            let answer_value = eee.answer_value;
                            if (eee.ctrl_type === 'toggleField') {
                                answer_value = Number(eee.answer_value) === 1 ? t('yes') : t('no')
                            } else if (eee.ctrl_type === 'checkboxField') {
                                answer_value = (eee.answer_value ?? []).join("; ")
                            } else if (eee.ctrl_type === 'dateField') {
                                answer_value = formatDate(eee.answer_value,"DD/MM/YYYY")
                            }
                            return renderIf(
                                eee.answer_value,
                                <div key={iii} className={classNames('space-x-2', className)}>
                                    <span className="text-color-400 italic">{`${eee.title} : `}</span>
                                    <span className="font-semibold text-color-100">
                                        {answer_value}
                                    </span>
                                </div>
                            )
                        }),
                        renderEmptyHolderMember("no data is available now", "the user has not provided an answer to your question")
                    )}
                </div>
            )}
        </Translate>
    )
}
